import _normalizeUrl from 'normalize-url';
import { parseDomain as parseDomain$1, fromUrl } from 'parse-domain';
import _parseUrl from 'url-parse';
import _urlRegex from 'url-regex';

function cleanUrl(url) {
  let newUrl;
  if (!url) {
    return null;
  }
  if (url.endsWith(";") || url.endsWith(".")) {
    url = url.slice(0, -1);
  }
  url = url.replace(/\s/g, "").replace("'", "").replace("..", ".").replace(",.", ".").replace(".,com", ".com").replace(",com", ".com").replace("http:/www.", "http://www.").replace("http://www.//", "http://www.").replace("http:/http://", "http://").replace("http://http//:", "http://").replace("http://http://", "http://").replace("http://http;//", "http://").replace("http://http//", "http://").replace("http://https//", "https://").replace("http://http@//", "http://");
  try {
    newUrl = new URL(
      normalizeUrl(
        url,
        {
          removeTrailingSlash: false,
          stripWWW: false
        }
      )
    );
  } catch {
    return;
  }
  return newUrl.href;
}
function convertToAbsolute(relativeUrl, absoluteUrl) {
  return new URL(relativeUrl, absoluteUrl).href;
}
function extractAppId(url) {
  const result = {
    id: null,
    platform: null,
    type: null
  };
  const patterns = [
    {
      platform: "android",
      regex: /play\.google\.com\/store\/apps\/details\?id=([^&]+)/,
      type: "app"
    },
    {
      platform: "android",
      regex: /play\.google\.com\/store\/apps\/dev\?.*id=([^&]+)/,
      type: "developer"
    },
    {
      platform: "ios",
      regex: /apps\.apple\.com\/.*\/app\/.*\/id(\d+)/,
      type: "app"
    },
    {
      platform: "ios",
      regex: /itunes\.apple\.com(?:\/[^\/]+)?\/app(?:\/[^\/]+)?\/id(\d+)/,
      type: "app"
    },
    {
      platform: "ios",
      regex: /apps\.apple\.com\/.*\/developer\/.*\/id(\d+)/,
      type: "developer"
    }
  ];
  for (const pattern of patterns) {
    const match = url.match(pattern.regex);
    if (match) {
      result.id = match[1];
      result.platform = pattern.platform;
      result.type = pattern.type;
      break;
    }
  }
  return result;
}
function extractSocialId(url) {
  const result = {
    id: void 0,
    idType: void 0,
    network: void 0
  };
  if (url && isValidUrl(url)) {
    url = url.trim();
    url = url.replace(/(^\w+:|^)\/\//, "");
    url = url.split("?")[0];
    if (url.endsWith("/")) {
      url = url.slice(0, -1);
    }
    if (url.includes("discord.com/") || url.includes("discord.gg/")) {
      result.network = "discord";
    } else if (url.includes("dribbble.com/")) {
      result.network = "dribbble";
    } else if (url.includes("facebook.com/")) {
      result.network = "facebook";
    } else if (url.includes("github.com/")) {
      result.network = "github";
    } else if (url.includes("instagram.com/")) {
      result.network = "instagram";
    } else if (url.includes("linkedin.com/")) {
      result.network = "linkedin";
    } else if (url.includes("mastodon.social/") || url.includes("mastodon.online/") || url.includes("mstdn.social/")) {
      result.network = "mastodon";
    } else if (url.includes("medium.com/")) {
      result.network = "medium";
    } else if (url.includes("patreon.com/")) {
      result.network = "patreon";
    } else if (url.includes("pinterest.")) {
      result.network = "pinterest";
    } else if (url.includes("reddit.com/")) {
      result.network = "reddit";
    } else if (url.includes("slack.com/")) {
      result.network = "slack";
    } else if (url.includes("snapchat.com/")) {
      result.network = "snapchat";
    } else if (url.includes("stackoverflow.com/")) {
      result.network = "stackoverflow";
    } else if (url.includes("steamcommunity.com/")) {
      result.network = "steam";
    } else if (url.includes(".substack.com")) {
      result.network = "substack";
    } else if (url.includes("threads.net/")) {
      result.network = "threads";
    } else if (url.includes("tiktok.com/")) {
      result.network = "tiktok";
    } else if (url.includes(".tumblr.com")) {
      result.network = "tumblr";
    } else if (url.includes("twitch.tv/")) {
      result.network = "twitch";
    } else if (url.includes("twitter.com/") || url.includes("x.com/")) {
      result.network = "twitter";
    } else if (url.includes("vimeo.com/")) {
      result.network = "vimeo";
    } else if (url.includes("vk.com/")) {
      result.network = "vkontakte";
    } else if (url.includes("angel.co/") || url.includes("wellfound.com/")) {
      result.network = "wellfound";
    } else if (url.includes("xing.com/")) {
      result.network = "xing";
    } else if (url.includes("yelp.com/")) {
      result.network = "yelp";
    } else if (url.includes("youtube.com/")) {
      result.network = "youtube";
    }
    if (result.network === "discord") {
      result.id = url.includes("discord.gg/") ? url.split("discord.gg/")[1] : url.split("/").at(-1) || "";
    } else if (result.network === "dribbble") {
      result.id = url.split("dribbble.com/")[1].split("/")[0];
    } else if (result.network === "facebook") {
      if (url.includes("/pages/")) {
        result.id = url.split("/pages/")[1]?.split("/")[0];
      } else {
        result.id = url.split("/")[1];
      }
    } else if (result.network === "github") {
      if (url.includes("/orgs/")) {
        result.id = url.split("/orgs/")[1]?.split("/")[0];
      } else {
        result.id = url.split("/")[1];
      }
    } else if (result.network === "instagram") {
      result.id = url.split("/")[1];
    } else if (result.network === "linkedin") {
      result.id = url.split(/\/company\/|\/in\/|\/school\//)[1]?.split("/")[0];
      if (typeof Number.parseInt(result.id) === "number" && !Number.isNaN(Number.parseInt(result.id))) {
        result.idType = "idNumeric";
      }
    } else if (result.network === "mastodon") {
      result.id = url.split("/")[1];
    } else if (result.network === "medium") {
      result.id = url.split("/")[1];
    } else if (result.network === "patreon") {
      result.id = url.split("/")[1];
    } else if (result.network === "pinterest") {
      result.id = url.split("/")[1];
    } else if (result.network === "reddit") {
      result.id = url.includes("/r/") ? url.split("/r/")[1]?.split("/")[0] : url.split("/")[1];
    } else if (result.network === "slack") {
      try {
        const urlObject = new URL(`https://${url}`);
        const parts = urlObject.hostname.split(".");
        if (parts.length === 3) {
          result.id = parts[0];
        }
      } catch {
      }
    } else if (result.network === "snapchat") {
      result.id = url.split("/add/")[1];
    } else if (result.network === "stackoverflow") {
      result.id = url.split("/questions/tagged/")[1];
    } else if (result.network === "steam") {
      result.id = url.split("/groups/")[1];
    } else if (result.network === "substack") {
      result.id = url.split(".")[0];
    } else if (result.network === "threads") {
      result.id = url.split("/")[1];
    } else if (result.network === "tiktok") {
      result.id = url.split("/")[1];
    } else if (result.network === "tumblr") {
      result.id = url.split(".")[0];
    } else if (result.network === "twitch") {
      result.id = url.split("/")[1];
    } else if (result.network === "twitter") {
      result.id = url.split("/")[1];
    } else if (result.network === "vimeo") {
      result.id = url.split("/")[1];
    } else if (result.network === "vkontakte") {
      result.id = url.split("/")[1];
    } else if (result.network === "wellfound") {
      if (url.includes("/company/")) {
        result.id = url.split("/company/")[1]?.split("/")[0];
      } else {
        result.id = url.split("/")[1];
      }
    } else if (result.network === "xing") {
      result.id = url.split("/pages/")[1];
    } else if (result.network === "yelp") {
      result.id = url.split("/biz/")[1];
    } else if (result.network === "youtube") {
      result.id = url.split(/\/channel\/|\/user\/|\/c\//)[1]?.split("/")[0];
      if (!result.id) {
        result.id = url.split("/")[1];
      }
    }
    if (result.id && !result.idType) {
      result.idType = "id";
    }
    if ([
      "mastodon",
      "snapchat",
      "threads",
      "tiktok",
      "twitter",
      "youtube"
    ].includes(`${result.network}`) && result.id?.startsWith("@")) {
      result.id = result.id.substring(1);
    }
  }
  return result;
}
function extractUrls(string) {
  const urlPattern = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g;
  return removeDuplicate(string.match(urlPattern) || []);
}
function getDomainName(url) {
  const parsedDomain = parseDomain(url);
  return parsedDomain.domain || parsedDomain?.icann?.domain || "";
}
function getHost(url) {
  const parsedUrl = parseUrl(url);
  return parsedUrl.host;
}
function getOrigin(url) {
  const urlObject = parseUrl(url);
  return urlObject.origin;
}
function getRootDomain(url) {
  try {
    const parsedDomain = parseDomain(url);
    if (!parsedDomain?.icann?.domain || !parsedDomain.icann?.topLevelDomains?.length) {
      return "";
    }
    return `${parsedDomain.icann.domain}.${parsedDomain.icann.topLevelDomains.join(".")}`;
  } catch {
    return "";
  }
}
function getRootDomainAndFull(url) {
  let root = "";
  let full = "";
  try {
    const parsedDomain = parseDomain(url);
    if (!parsedDomain?.icann?.domain || !parsedDomain.icann?.topLevelDomains?.length) {
      return {
        full,
        parsed: void 0,
        root
      };
    }
    root = `${parsedDomain.icann.domain}.${parsedDomain.icann.topLevelDomains.join(".")}`;
    if (parsedDomain.icann?.subDomains?.length) {
      full = `${parsedDomain.icann.subDomains.join(".")}.${parsedDomain.icann.domain}.${parsedDomain.icann.topLevelDomains.join(".")}`;
    } else {
      full = root;
    }
    return {
      full,
      parsed: parsedDomain,
      root
    };
  } catch {
    return {
      full,
      parsed: void 0,
      root
    };
  }
}
function getTld(url) {
  if (!url.includes(".")) {
    return "";
  }
  const parsedDomain = parseDomain(url);
  return (parsedDomain.topLevelDomains || []).join(".");
}
function isValidFullDomain(value) {
  try {
    const domainParsed = parseDomain(value);
    if (domainParsed.type !== "LISTED" || !domainParsed?.domain) {
      return false;
    }
    return true;
  } catch {
    return false;
  }
}
function isValidRootDomain(value) {
  try {
    const domainParsed = parseDomain(value);
    if (
      // Make sure the domain is valid
      domainParsed.type !== "LISTED" || !domainParsed?.icann?.domain && !domainParsed?.domain || ((domainParsed?.subDomains || []).length > 0 || (domainParsed?.icann?.subDomains || []).length > 0)
    ) {
      return false;
    }
    return true;
  } catch {
    return false;
  }
}
function isValidSubdomain(value) {
  try {
    const domainParsed = parseDomain(value);
    return (domainParsed.subDomains || []).length > 0 || (domainParsed.icann.subDomains || []).length > 0;
  } catch {
    return false;
  }
}
function isValidUrl(url) {
  return _urlRegex().test(url) && !url.startsWith("data:image/");
}
function normalizeUrl(...args) {
  return _normalizeUrl(...args);
}
function parseDomain(url) {
  const cleanedUrl = cleanUrl(url);
  return parseDomain$1(fromUrl(cleanedUrl || ""));
}
function parseQueryString(url) {
  const result = {};
  const parsedURL = new URL(url);
  const searchParams = new URLSearchParams(parsedURL.search);
  for (const [key, value] of searchParams.entries()) {
    result[key] = value;
  }
  return result;
}
function parseUrl(url) {
  const cleanedUrl = cleanUrl(url) || "";
  return _parseUrl(cleanedUrl);
}
function removeDuplicate(urls) {
  return [...new Set(urls)];
}
function removeParams(url) {
  url = url.toLowerCase().trim();
  url = url.split("?")[0];
  url = url.split("#")[0];
  return url;
}
function resolveUrlPath(url) {
  const normalizedUrl = normalizeUrl(url);
  const { pathname } = _parseUrl(normalizedUrl);
  return pathname;
}

export { cleanUrl, convertToAbsolute, extractAppId, extractSocialId, extractUrls, getDomainName, getHost, getOrigin, getRootDomain, getRootDomainAndFull, getTld, isValidFullDomain, isValidRootDomain, isValidSubdomain, isValidUrl, normalizeUrl, parseDomain, parseQueryString, parseUrl, removeDuplicate, removeParams, resolveUrlPath };
